import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { T2dEntityTreePickerService } from './t2d-entity-tree-picker.service';
import { T2dEntityTreePickerComponent } from './t2d-entity-tree-picker.component';
import type { EntityTreePickerSelection } from './entity-tree-picker.types';

@Component({
  selector: 't2d-entity-tree-picker-host',
  standalone: true,
  imports: [T2dEntityTreePickerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (picker.isOpen()) {
      <t2d-entity-tree-picker
        (selected)="onSelected($event)"
        (closed)="onClosed()"
      />
    }
  `,
})
export class T2dEntityTreePickerHostComponent {
  protected readonly picker = inject(T2dEntityTreePickerService);

  protected onSelected(sel: EntityTreePickerSelection): void {
    this.picker.resolve(sel);
  }

  protected onClosed(): void {
    this.picker.resolve(null);
  }
}
